interface DownloadIconProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
}

export const DownloadIcon = ({
  width = 20,
  height = 20,
  className = '',
  color = 'currentColor',
}: DownloadIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={color}
      className={className}>
      <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
    </svg>
  );
};

